export default function XSD_SchemaTag() {
  return (
    <div>
      <h1>XSD_SchemaTag</h1>
      <p>This is the XSD_SchemaTag component.</p>
    </div>
  );
}